<template>
  <div id="UploadHeadImg">
    <el-dialog :center="true" title="用户头像上传" :visible.sync="dialogVisible" width="880px">
      <ebImgCropper id="headImg" ref="ebImgCropper" @cropper-success="cropperSuccessHandle" :imgType="imgType"/>
      <div class="eb-button-group">
        <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="dialogVisible = false">取消</el-button>
        <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="confirm()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import eventBus from '@/plugins/event-bus';
import { uploadFile } from '@/plugins/upload-file';
import ebImgCropper from '@/components/common/eb-img-cropper';
export default {
  name: 'UploadHeadImg',
  components: {
    ebImgCropper
  },
  data() {
    return {
      dialogVisible: false,
      showName: '',
      userId: '',
      headImgUrl: '/user/editUser',
      type: '',
      imgType: 'headImg'
    };
  },
  created() {
    eventBus.$on('uploadHeadImg', (showName, userId, uploadType) => {
      this.dialogVisible = true;
      this.showName = showName;
      this.userId = userId;
      this.type = uploadType;
    });
  },
  methods: {
    cropperSuccessHandle(target, imgData) {
      let formData = {
        channel: 'head-img',
        showName: this.showName,
        userId: this.userId,
        headImgCropper: imgData
      };
      uploadFile(
        target,
        this.headImgUrl,
        formData,
        res => {
          let { data } = res;
          if (data.returnCode === '00') {
            this.$message.error('头像上传失败');
          } else {
            this.$parent.user.headImg = '';
            if (this.type === 'editUser') {
              eventBus.$emit('userEditSuccess', 'headImg');
            } else {
              eventBus.$emit('loadUserInfo', 'headImg');
            }
            this.dialogVisible = false;
            this.$message.success('头像上传成功！');
          }
        },
        complete => {}
      );
    },
    confirm() {
      this.$refs.ebImgCropper.submit();
    }
  },
  beforeDestroy() {
    eventBus.$off('uploadHeadImg');
  }
};
</script>
<style scoped lang="less">
</style>
